import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  Listreceptions_articles,
  cloturerReceptionbysocieteApi,
  coloturerReceptionbysocieteApi,
  confirmerReceptionbysocieteApi,
  currentpage,
  findArticlereceptionApi,
  findArticlereceptionAvantClotureApi,
  findReceptionbysocieteApi,
  totalPages,
} from "../../_App/Redux/Slices/receptionArticles/receptionArticlesSlice";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ReceptionArticlesType } from "../../_App/Types/Entites/ReceptionArticles/ReceptionArticlesType";
import TicketArticle from "../TicketArticle/TicketArticle";
import BonSortie from "./BonSortie";
import Pagination from "../../Shared/Pagination/Pagination";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import FiltreReception from "./FiltreReception";
import { allOrganisationsApi } from "../../_App/Redux/Slices/organisations/organisationSlice";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  findDepotsBySocieteApi,
  ListDepotByOrganisation,
} from "../../_App/Redux/Slices/depot/depotSlice";
import { formatDate, formatDateAndTime } from "../../_App/Helpers/helpers";
import {
  findFourinsseurBySocieteApi,
  ListFournisseurs,
} from "../../_App/Redux/Slices/fournisseur/fournisseurSlice";
interface SelectionsState {
  [key: string]: any[];
}
export default function ReceptionTable({
  t,
  societeId,
  setshowReception,
  setreception,
  reception,
  setImpression,
  setshowModelTicket,
  showModelTicket,
  setlistTicket,
  listTicket,
}: any) {
  const dispatch = useAppDispatch();
  const listReception = useAppSelector(Listreceptions_articles);
  const [showModalBonSortie, setshowModalBonSortie] = useState(false);
  const organisationConnecte = useAppSelector(SelectedOrganisationId);
  const [dataBonSortie, setdataBonSortie] = useState(null);
  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const listDepots = useAppSelector(ListDepotByOrganisation);
  const [index, setindex] = useState(!current_page ? 1 : current_page);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const [Filtre, setFiltre] = useState<any>({
    organisation: "null",
    etat: "tout",
    depots: "",
    date_debut: formatDate(today),
    date_fin: formatDate(today),
    codeReception: "",
    index: index,
    societe_id: societeId,
    fournisseur: "",
  });

  useEffect(() => {
    if (societeId) {
      dispatch(allOrganisationsApi(societeId));
      dispatch(findDepotsBySocieteApi(societeId));
      dispatch(findFourinsseurBySocieteApi(societeId));
    }
  }, [societeId]);

  useEffect(() => {
    if (organisationConnecte) {
      setFiltre((prev: any) => ({
        ...prev,
        organisation: organisationConnecte,
      }));
    }
  }, [organisationConnecte]);

  useEffect(() => {
    const orgselected =
      Filtre.organisation === "null" ? null : Filtre.organisation;
    if (
      orgselected &&
      listDepots[orgselected] &&
      listDepots[orgselected].length !== 0
    ) {
      const findDepots = listDepots[orgselected][0];
      if (findDepots) {
        setFiltre((prev: any) => ({
          ...prev,
          depots: findDepots._id,
        }));
      }
    }
  }, [Filtre.organisation, listDepots]);

  useEffect(() => {
    dispatch(findReceptionbysocieteApi(Filtre));
  }, []);

  useEffect(() => {
    const copie = { ...Filtre };
    copie.index = index;
    setFiltre(copie);

    dispatch(findReceptionbysocieteApi(copie));
  }, [index]);

  const cloturer = async (id: string) => {
    const data = { reception_id: id };
    const response = await dispatch(cloturerReceptionbysocieteApi(data));
    if (response?.payload.success) {
      ToastSuccess(response?.payload.message);
      window.location.reload();
    } else {
      ToastWarning(response?.payload.message);
    }
  };
  const confirmer = async (id: string) => {
    const data = { reception_id: id };
    const response = await dispatch(confirmerReceptionbysocieteApi(data));
    if (response?.payload.success) {
      ToastSuccess(response?.payload.message);
      window.location.reload();
    } else {
      ToastWarning(response?.payload.message);
    }
  };

  const findArticleReception = async (reception: ReceptionArticlesType) => {
    const response = await dispatch(findArticlereceptionApi(reception._id));
    // console.log('response.payload',response.payload)
    const listticket = response.payload
      .filter((element: any) => element.qte > 0)
      .map((element: any) => {
        return {
          famille: element.souscategorie?.libelle?.abr,
          marque: element.marque?.libelle?.fr,
          ref: element.articleparent?.code_article,
          taille:
            element?.caracteristiques.length !== 0
              ? element.caracteristiques[1]?.value?.libelle
                ? element.caracteristiques[0]?.value
                : element.caracteristiques[1]?.value
              : element?.code_article.split("-")[2],
          couleur:
            element?.caracteristiques.length !== 0
              ? element.caracteristiques[0]?.value?.libelle
                ? element.caracteristiques[0]?.value?.libelle
                : element.caracteristiques[1]?.value?.libelle
              : element?.code_article.split("-")[1],
          prix: element?.prix_vente_ttc,
          coderecption: reception?.code_reception,
          code_a_barre: element?.code_a_barre[0],
          qte: element?.qte,
          solde: element?.solde,
        };
      });

    setlistTicket(listticket);
    setImpression(true);
    setshowModelTicket(true);
  };

  const findArticlereceptionAvantCloture = async (
    reception: ReceptionArticlesType,
  ) => {
    const response = await dispatch(
      findArticlereceptionAvantClotureApi(reception._id),
    );
    // console.log('response.payload',response.payload)
    const listticket = response.payload
      .filter((element: any) => element.qte > 0)
      .map((element: any) => {
        return {
          famille: element.famille?.libelle?.abr,
          marque: element.marque?.libelle?.fr,
          ref: element.ref,
          taille:
            element?.caracteristiques.length !== 0
              ? element.caracteristiques[1]?.value?.libelle
                ? element.caracteristiques[0]?.value
                : element.caracteristiques[1]?.value
              : element?.code_article.split("-")[2],
          couleur:
            element?.caracteristiques.length !== 0
              ? element.caracteristiques[0]?.value?.libelle
                ? element.caracteristiques[0]?.value?.libelle
                : element.caracteristiques[1]?.value?.libelle
              : element?.code_article.split("-")[1],
          prix: element?.prix,
          coderecption: element?.code_reception,
          code_a_barre: element?.code_a_barre[0],
          qte: element?.qte,
          solde: null,
        };
      });
    setImpression(false);
    setlistTicket(listticket);
    setshowModelTicket(true);
  };
  const searchfiltre = async () => {
    const copie = { ...Filtre };
    copie.index = 1;
    setindex(1);
    setFiltre(copie);

    dispatch(findReceptionbysocieteApi(copie));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const copie = { ...Filtre };
    copie.codeReception = value;
    copie.index = 1;
    setFiltre((prev: any) => ({
      ...prev,
      codeReception: value,
      index: 1,
    }));

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      dispatch(findReceptionbysocieteApi(copie));
    }, 500);
  };

  return (
    <>
      <div className="  bg-white" style={{ padding: "10px" }}>
        <div className="row">
          <div className="search-bar">
            <input
              autoFocus
              style={{ background: "#f1f2f3", border: "none" }}
              type="text"
              id="code_input"
              className={"form-control   col-6"}
              placeholder={t("Code Reception ")}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <FiltreReception
          t={t}
          Filtre={Filtre}
          setFiltre={setFiltre}
          listDepots={listDepots}
          searchfiltre={searchfiltre}
        />
      </div>
      <div className="col-lg-12  mt-5   bg-white">
        <div className="inv--product-table-section ">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>{t("Action")}</th>
                  <th>{t("etat")}</th>
                  <th> {t("Code Reception")}</th>

                  <th>{t("Organisation")}</th>
                  <th>{t("Depots")}</th>
                  <th>{t("Cree par")}</th>

                  <th>{t("Date")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {listReception.length !== 0 &&
                  listReception.map((item: any, index: number) => (
                    <tr key={item._id}>
                      {!item.confirmer ? (
                        <td
                          className="c-primary pointer"
                          onClick={() => cloturer(item._id)}
                        >
                          confirmer
                        </td>
                      ) : !item.cloturer ? (
                        <>
                          <td
                            className="c-primary pointer"
                            onClick={() => cloturer(item._id)}
                          >
                            cloturer
                          </td>
                          <td
                            className="c-primary pointer"
                            onClick={() =>
                              findArticlereceptionAvantCloture(item)
                            }
                          >
                            Imprimer tickets
                          </td>
                        </>
                      ) : (
                        <td
                          className="c-primary pointer"
                          onClick={() => findArticleReception(item)}
                        >
                          Imprimer tickets
                        </td>
                      )}

                      {!item.cloturer ? (
                        !item.confirmer ? (
                          <td>{t("en cours")}</td>
                        ) : (
                          <td className="color-red">{t("confirmé")}</td>
                        )
                      ) : (
                        <td className="color-red">{t("cloturé")}</td>
                      )}
                      <td
                        className="lien-bleu-souligne"
                        onClick={() => {
                          setreception(item);
                          setshowReception(true);
                        }}
                      >
                        {item?.code_reception}
                      </td>

                      <td>{item?.organisation_id?.nom || "societe"}</td>
                      <td>{item?.depot_id?.libelle || "--"}</td>
                      <td>
                        {item?.createdBy?.nom} {item?.createdBy?.prenom}
                      </td>

                      <td>{formatDateAndTime(item?.createdAt)}</td>
                      {item.bonSorties &&
                        item.bonSorties !== null &&
                        Object.keys(item.bonSorties) &&
                        Object.keys(item.bonSorties).length !== 0 && (
                          <td
                            className="lien-bleu-souligne"
                            onClick={() => {
                              setdataBonSortie(item);
                              setshowModalBonSortie(true);
                            }}
                          >
                            Bon Sortie
                          </td>
                        )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <BonSortie
          ShowModal={showModalBonSortie}
          setShowModal={setshowModalBonSortie}
          reception={dataBonSortie}
          t={t}
        />
        <div className="row layout-spacing">
          <PaginationLayout
            index={index}
            nbrpage={current_page}
            totalpages={totalpages}
            setindex={setindex}
          />
        </div>
      </div>
    </>
  );
}
